<ion-content [fullscreen]="true" class="auth-content">
  <!-- ───────── Sign in ───────── -->
  <app-auth-bg *ngIf="!deactivated">
    <!-- Logo + wordmark -->
    <div class="signin__logo">
      <img src="./assets/img/pcs-badge.png" alt="" class="signin__badge" />
      <div class="signin__wordmark">Pro Captain Staffing</div>
      <div class="signin__subtitle">Sign in to your account</div>
    </div>

    <!-- Form -->
    <form class="signin__form auth-screen" [formGroup]="credentials" (ngSubmit)="login()">
      <!-- Inline wrong-credentials banner -->
      <div class="auth-error-banner" *ngIf="errorState === 'wrongPassword'">
        <ion-icon name="warning-outline"></ion-icon>
        <div class="auth-error-banner__text">
          That email and password don't match. Try again, or
          <span class="auth-error-banner__link" (click)="onForgot()">reset your password</span>.
        </div>
      </div>

      <!-- Email -->
      <div class="auth-field">
        <div class="auth-field__label-row">
          <span class="auth-field__label">Email</span>
          <ion-icon
            *ngIf="email?.valid && email?.value"
            class="auth-field__check"
            name="checkmark-outline"></ion-icon>
        </div>
        <div
          class="auth-input"
          [class.auth-input--valid]="email?.valid && email?.value"
          [class.auth-input--error]="email?.touched && email?.invalid && email?.value">
          <input
            type="email"
            inputmode="email"
            autocomplete="email"
            placeholder="you@company.com"
            formControlName="email" />
        </div>
        <div class="auth-field__error" *ngIf="email?.touched && email?.invalid && email?.value">
          <ion-icon name="warning-outline"></ion-icon> Enter a valid email
        </div>
      </div>

      <!-- Password -->
      <div class="auth-field signin__password">
        <div class="auth-field__label-row">
          <span class="auth-field__label">Password</span>
        </div>
        <div class="auth-input">
          <input
            [type]="showPwd ? 'text' : 'password'"
            autocomplete="current-password"
            placeholder="Enter your password"
            formControlName="password"
            (input)="onPasswordInput()"
            (keyup.enter)="login()" />
          <button
            type="button"
            class="auth-input__toggle"
            (click)="showPwd = !showPwd"
            [attr.aria-label]="showPwd ? 'Hide password' : 'Show password'">
            <ion-icon [name]="showPwd ? 'eye-off-outline' : 'eye-outline'"></ion-icon>
          </button>
        </div>
      </div>

      <div class="signin__forgot">
        <button type="button" class="auth-link" (click)="onForgot()">Forgot password?</button>
      </div>

      <div class="signin__cta">
        <button type="submit" class="auth-primary" [disabled]="credentials.invalid || submitting">
          <ng-container *ngIf="submitting">
            <span class="auth-spinner"></span> Signing you in…
          </ng-container>
          <ng-container *ngIf="!submitting">Sign in</ng-container>
        </button>
      </div>

      <div class="signin__spacer"></div>

      <div class="signin__footer">
        New to ProCap?
        <button type="button" class="auth-link signin__footer-link" (click)="onClaim()">
          Set up your account
        </button>
      </div>
    </form>
  </app-auth-bg>

  <!-- ───────── Account paused (deactivated) ───────── -->
  <app-auth-bg *ngIf="deactivated" [dim]="true">
    <div class="paused">
      <!-- Desaturated brand badge with PAUSED cue -->
      <div class="paused__badge-wrap">
        <img src="./assets/img/pcs-badge.png" alt="" class="paused__badge" />
        <div class="paused__bars">
          <span></span><span></span>
        </div>
        <div class="paused__pill">Paused</div>
      </div>

      <div class="paused__title">Account paused</div>
      <div class="paused__body">
        Your ProCap account is no longer active. Reach out to your administrator to restore access.
      </div>

      <!-- Admin contact card -->
      <div class="paused__card">
        <div class="paused__card-icon"><ion-icon name="business-outline"></ion-icon></div>
        <div class="paused__card-text">
          <div class="paused__card-label">Your admin</div>
          <div class="paused__card-value">{{ adminEmail }}</div>
        </div>
      </div>
    </div>

    <div class="paused__actions">
      <button type="button" class="auth-primary" (click)="emailAdministrator()">
        <ion-icon name="mail-outline"></ion-icon> Email administrator
      </button>
      <button type="button" class="paused__alt" (click)="signInAsDifferent()">
        Sign in as a different user
      </button>
    </div>
  </app-auth-bg>
</ion-content>
